module.exports = __webpack_public_path__ + "img/product_3.6b56f118.png";